import cx from 'classnames'
import { format, parseISO } from 'date-fns'
import React from 'react'

import Image from '@cinch/oxd-components/image/src'
import { Text, TextStyles } from '@cinch-labs/design-system'

import * as styles from './guide-summary.module.css'

interface CustomStyles {
  imageContainer?: string
  image?: string
  customImageContainer?: string
  customImage?: string
  meta?: string
  title?: string
  description?: string
  metaContainer?: string
}

export interface GuideSummaryProps {
  id: string
  featured?: boolean
  headline: string
  datePublished?: string // ISO String
  description: string
  image?: string | React.ReactNode
  className?: string
  customStyles?: CustomStyles
}

const GuideSummary: React.FC<GuideSummaryProps> = ({
  id,
  featured = false,
  headline,
  datePublished = '',
  description,
  image,
  className = '',
  customStyles = {},
}) => (
  <article data-testid="guide-summary" className={cx(styles.guide, className)} data-featured={featured} data-uid={id}>
    {image && typeof image === 'string' && (
      <div className={cx(styles.imageContainer, customStyles.imageContainer, { [styles.featured]: featured })}>
        <Image className={cx(styles.image, customStyles.image)} alt={headline} src={image} isLazy={true} />
      </div>
    )}
    {image && typeof image !== 'string' && (
      <div
        className={cx(styles.imageContainer, customStyles.imageContainer, customStyles.customImageContainer, {
          [styles.featured]: featured,
        })}
      >
        <div className={cx(styles.customImage, customStyles.customImage, { [styles.featured]: featured })}>{image}</div>
      </div>
    )}
    <div className={customStyles.metaContainer}>
      {datePublished && (
        <Text
          oxford={true}
          type={TextStyles.caption}
          element="div"
          className={cx(styles.meta, customStyles.meta)}
          data-published={datePublished}
        >
          {format(parseISO(datePublished), 'MMM d yyyy')}
        </Text>
      )}
      <Text
        oxford={true}
        type={featured ? TextStyles.vehicleTitle : TextStyles.mainTitle}
        element="h3"
        className={cx(styles.title, customStyles.title)}
      >
        {headline}
      </Text>
      <Text
        oxford={true}
        type={featured ? TextStyles.body1 : TextStyles.body2}
        element="p"
        className={cx(styles.description, customStyles.description)}
      >
        {description}
      </Text>
    </div>
  </article>
)

export default GuideSummary
